// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dict-container {
  width: calc(100% - 50px);
  height: calc(100% - 65px);
  padding: 25px;
  padding-top: 5px;
}
.dict-word {
  font-size: 30px;
  font-weight: bold;
  line-height: 1.5;
  display: inline-block;
  margin-top: 10px;
  margin-left: 5px;
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wiki-image {
  float: right;
  width: 43%;
}
.wiki-text::first-letter {
  font-size: 3rem;
}
.dict-definition {
  line-height: 30px;
}
.dict-original-word {
  opacity: 0.6;
  line-height: 20px;
  margin-top: 10px;
  margin-left: 5px;
}
.dict-word-type,
.dict-learn-more {
  color: #2084e8;
  margin-bottom: 5px;
  margin-top: 15px;
}
.dict-learn-more {
  cursor: pointer;
}
.dict-text-box {
  opacity: 1;
  border-radius: 5px;
  margin-top: 5px;
  height: calc(100% - 45px);
  -webkit-user-select: text;
          user-select: text;
  overflow-y: scroll;
  padding: 8px;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 20px;
}

.dict-button-container {
  position: absolute;
  bottom: 8px;
  right: 20px;
}
.dict-service-container {
  position: absolute;
  /* width: calc(100% - 32px); */
  top: 30px;
  right: 25px;
}
.dict-service-selector {
  width: 100px;
  height: 30px;
  opacity: 1;
  font-size: 15px;
  line-height: 30px;
  border: none;
  cursor: pointer;
  color: #2084e8;
  background-color: transparent;
}
.add-dialog-shelf-list-option {
  color: black;
}
.dict-url {
  font-size: 12px;
  cursor: pointer;
  text-align: center;
  margin-top: 20px;
}
/* .dict-container .r0bn4c {
  font-weight: bold;
  color: #2084e8;
}
.dict-container .r0bn4c::before {
  content: "[";
  font-weight: bold;
}
.dict-container .r0bn4c::after {
  content: "]";
  font-weight: bold;
} */
/* .dict-container ol {
  counter-reset: my-counter;
  list-style-type: none;
} */

/* .dict-container li:before {
  counter-increment: my-counter;
  content: counter(my-counter) ". ";
  font-weight: bold;
} */
/* .dict-container li div {
  display: inline;
} */
/* .dict-container ul {
  counter-reset: my-counter;
}

.dict-container li {
  counter-increment: my-counter;
}

.dict-container li::before {
  content: counter(my-counter) ". ";
  font-weight: bold;
} */
/* 在 popupDict.css 中添加这些规则，它们会覆盖 reset.css 中的全局规则 */
.dict-container ul {
  list-style-type: disc !important; /* 实心圆点 */
  padding-left: 2em !important; /* 添加缩进 */
  margin: 1em 0 !important; /* 添加上下边距 */
}

.dict-container ol {
  list-style-type: decimal !important; /* 数字编号 */
  padding-left: 2em !important; /* 添加缩进 */
  margin: 1em 0 !important; /* 添加上下边距 */
}

.dict-container li {
  list-style: inherit !important; /* 继承父元素的列表样式 */
  display: list-item !important; /* 显示为列表项 */
  margin: 0.5em 0 !important; /* 添加上下边距 */
}

/* 定义嵌套列表的样式 */
.dict-container ul ul {
  list-style-type: circle !important; /* 二级列表使用空心圆点 */
}

.dict-container ul ul ul {
  list-style-type: square !important; /* 三级列表使用方块 */
}

.dict-container ol ol {
  list-style-type: lower-alpha !important; /* 二级有序列表使用小写字母 */
}
.audio-player {
  width: 100px;
  height: 30px;
  margin-right: 10px;
}
.audio-label {
  display: inline-block;
  font-weight: bold;
  position: relative;
  bottom: 9px;
  margin-right: 5px;
}
.audio-note {
  display: inline-block;
  position: relative;
  bottom: 9px;
  margin-right: 5px;
}
.audio-player::-webkit-media-controls-timeline {
  display: none !important;
}

.audio-player::-webkit-media-controls-current-time-display {
  display: none !important;
}

.audio-player::-webkit-media-controls-time-remaining-display {
  display: none !important;
}

.audio-player::-webkit-media-controls-mute-button {
  display: none !important;
}

.audio-player::-webkit-media-controls-volume-slider {
  display: none !important;
}

.audio-player::-webkit-media-controls-volume-slider-container {
  display: none !important;
}
.audio-container {
  display: inline-block;
  width: 50px;
  height: 30px;
  overflow: hidden;
  border-radius: 15px;
  margin-right: 10px;
  margin-left: 10px;
  margin-top: -10px;
  position: relative;
  top: 10px;
}

.dict-ai-answer-container {
  margin-top: 10px;
}

.dict-ai-answer-title {
  color: #2084e8;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.dict-ai-answer-icon {
  margin-right: 6px;
  font-size: 16px;
}

.dict-ai-answer-waiting {
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.7;
  font-size: 14px;
}

.dict-ai-answer-content {
  font-size: 14px;
  line-height: 22px;
  -webkit-user-select: text;
          user-select: text;
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popupDict/popupDict.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;;;;;;;;;GAWG;AACH;;;GAGG;;AAEH;;;;GAIG;AACH;;GAEG;AACH;;;;;;;;;;;GAWG;AACH,mDAAmD;AACnD;EACE,gCAAgC,EAAE,SAAS;EAC3C,4BAA4B,EAAE,SAAS;EACvC,wBAAwB,EAAE,WAAW;AACvC;;AAEA;EACE,mCAAmC,EAAE,SAAS;EAC9C,4BAA4B,EAAE,SAAS;EACvC,wBAAwB,EAAE,WAAW;AACvC;;AAEA;EACE,8BAA8B,EAAE,eAAe;EAC/C,6BAA6B,EAAE,WAAW;EAC1C,0BAA0B,EAAE,WAAW;AACzC;;AAEA,cAAc;AACd;EACE,kCAAkC,EAAE,eAAe;AACrD;;AAEA;EACE,kCAAkC,EAAE,aAAa;AACnD;;AAEA;EACE,uCAAuC,EAAE,iBAAiB;AAC5D;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":[".dict-container {\n  width: calc(100% - 50px);\n  height: calc(100% - 65px);\n  padding: 25px;\n  padding-top: 5px;\n}\n.dict-word {\n  font-size: 30px;\n  font-weight: bold;\n  line-height: 1.5;\n  display: inline-block;\n  margin-top: 10px;\n  margin-left: 5px;\n  max-width: 250px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.wiki-image {\n  float: right;\n  width: 43%;\n}\n.wiki-text::first-letter {\n  font-size: 3rem;\n}\n.dict-definition {\n  line-height: 30px;\n}\n.dict-original-word {\n  opacity: 0.6;\n  line-height: 20px;\n  margin-top: 10px;\n  margin-left: 5px;\n}\n.dict-word-type,\n.dict-learn-more {\n  color: #2084e8;\n  margin-bottom: 5px;\n  margin-top: 15px;\n}\n.dict-learn-more {\n  cursor: pointer;\n}\n.dict-text-box {\n  opacity: 1;\n  border-radius: 5px;\n  margin-top: 5px;\n  height: calc(100% - 45px);\n  user-select: text;\n  overflow-y: scroll;\n  padding: 8px;\n  box-sizing: border-box;\n  font-size: 15px;\n  line-height: 20px;\n}\n\n.dict-button-container {\n  position: absolute;\n  bottom: 8px;\n  right: 20px;\n}\n.dict-service-container {\n  position: absolute;\n  /* width: calc(100% - 32px); */\n  top: 30px;\n  right: 25px;\n}\n.dict-service-selector {\n  width: 100px;\n  height: 30px;\n  opacity: 1;\n  font-size: 15px;\n  line-height: 30px;\n  border: none;\n  cursor: pointer;\n  color: #2084e8;\n  background-color: transparent;\n}\n.add-dialog-shelf-list-option {\n  color: black;\n}\n.dict-url {\n  font-size: 12px;\n  cursor: pointer;\n  text-align: center;\n  margin-top: 20px;\n}\n/* .dict-container .r0bn4c {\n  font-weight: bold;\n  color: #2084e8;\n}\n.dict-container .r0bn4c::before {\n  content: \"[\";\n  font-weight: bold;\n}\n.dict-container .r0bn4c::after {\n  content: \"]\";\n  font-weight: bold;\n} */\n/* .dict-container ol {\n  counter-reset: my-counter;\n  list-style-type: none;\n} */\n\n/* .dict-container li:before {\n  counter-increment: my-counter;\n  content: counter(my-counter) \". \";\n  font-weight: bold;\n} */\n/* .dict-container li div {\n  display: inline;\n} */\n/* .dict-container ul {\n  counter-reset: my-counter;\n}\n\n.dict-container li {\n  counter-increment: my-counter;\n}\n\n.dict-container li::before {\n  content: counter(my-counter) \". \";\n  font-weight: bold;\n} */\n/* 在 popupDict.css 中添加这些规则，它们会覆盖 reset.css 中的全局规则 */\n.dict-container ul {\n  list-style-type: disc !important; /* 实心圆点 */\n  padding-left: 2em !important; /* 添加缩进 */\n  margin: 1em 0 !important; /* 添加上下边距 */\n}\n\n.dict-container ol {\n  list-style-type: decimal !important; /* 数字编号 */\n  padding-left: 2em !important; /* 添加缩进 */\n  margin: 1em 0 !important; /* 添加上下边距 */\n}\n\n.dict-container li {\n  list-style: inherit !important; /* 继承父元素的列表样式 */\n  display: list-item !important; /* 显示为列表项 */\n  margin: 0.5em 0 !important; /* 添加上下边距 */\n}\n\n/* 定义嵌套列表的样式 */\n.dict-container ul ul {\n  list-style-type: circle !important; /* 二级列表使用空心圆点 */\n}\n\n.dict-container ul ul ul {\n  list-style-type: square !important; /* 三级列表使用方块 */\n}\n\n.dict-container ol ol {\n  list-style-type: lower-alpha !important; /* 二级有序列表使用小写字母 */\n}\n.audio-player {\n  width: 100px;\n  height: 30px;\n  margin-right: 10px;\n}\n.audio-label {\n  display: inline-block;\n  font-weight: bold;\n  position: relative;\n  bottom: 9px;\n  margin-right: 5px;\n}\n.audio-note {\n  display: inline-block;\n  position: relative;\n  bottom: 9px;\n  margin-right: 5px;\n}\n.audio-player::-webkit-media-controls-timeline {\n  display: none !important;\n}\n\n.audio-player::-webkit-media-controls-current-time-display {\n  display: none !important;\n}\n\n.audio-player::-webkit-media-controls-time-remaining-display {\n  display: none !important;\n}\n\n.audio-player::-webkit-media-controls-mute-button {\n  display: none !important;\n}\n\n.audio-player::-webkit-media-controls-volume-slider {\n  display: none !important;\n}\n\n.audio-player::-webkit-media-controls-volume-slider-container {\n  display: none !important;\n}\n.audio-container {\n  display: inline-block;\n  width: 50px;\n  height: 30px;\n  overflow: hidden;\n  border-radius: 15px;\n  margin-right: 10px;\n  margin-left: 10px;\n  margin-top: -10px;\n  position: relative;\n  top: 10px;\n}\n\n.dict-ai-answer-container {\n  margin-top: 10px;\n}\n\n.dict-ai-answer-title {\n  color: #2084e8;\n  font-weight: bold;\n  font-size: 14px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.dict-ai-answer-icon {\n  margin-right: 6px;\n  font-size: 16px;\n}\n\n.dict-ai-answer-waiting {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  opacity: 0.7;\n  font-size: 14px;\n}\n\n.dict-ai-answer-content {\n  font-size: 14px;\n  line-height: 22px;\n  user-select: text;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
